/**
 * Block node types a rich-text section accepts.
 *
 * Both ends of the document pipeline gate on this list and they must not drift:
 * the Convex draft projection decides what an assistant may write into a rich
 * section, and the web app's stored-document validator decides what may be read
 * back. When the backend permitted a node the frontend validator did not (LAT-938
 * found `horizontalRule`, produced by markdown `---`), the stored document became
 * unreadable — the entity page threw on open instead of rendering the content.
 *
 * Surfaces may extend this list with their own node types, but never narrow it.
 */
export const RICH_SECTION_BLOCK_NODE_TYPES = [
    "paragraph",
    "heading",
    "bulletList",
    "orderedList",
    "codeBlock",
    "blockquote",
    "horizontalRule",
    "image",
];
